import type { TFunction } from 'i18next';

const CODE_KEYS: Record<string, string> = {
    collection_not_active: 'form.collectWorkspace.sharedLinkNotOpenResponses',
    collection_not_open: 'form.collectWorkspace.sharedLinkNotOpenResponses',
    guide_not_approved: 'form.collectWorkspace.sharedLinkNotApproved',
    collection_closed: 'form.collectWorkspace.sharedLinkClosed',
    role_required: 'form.collectWorkspace.sharedLinkPickRole',
    invalid_role: 'form.collectWorkspace.sharedLinkInvalidRole',
    max_responders_reached: 'form.collectWorkspace.sharedLinkMaxResponders',
    invalid_link: 'form.collectWorkspace.sharedLinkInvalid',
};

/** Map API error codes from shared responder link endpoints to i18n strings. */
export function sharedLinkErrorMessage(
    t: TFunction,
    opts?: { code?: string | null; description?: string | null },
): string {
    const code = String(opts?.code ?? '').trim();
    const key = CODE_KEYS[code];
    if (key) {
        return t(key);
    }
    const desc = String(opts?.description ?? '').trim();
    if (desc && desc !== code) {
        return desc;
    }
    return t('navigation.anErrorOccurred');
}
